import { selectCurrentAccount, selectCurrentSubscription } from "fond/api";
import { BillingCycle } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

/**
 * Gets the pending billing cycle of the current subscription.
 */
export const useGetPendingBillingCycle = (): BillingCycle | undefined => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const currentSubscription = useAppSelector((state) => currentAccount && selectCurrentSubscription(state, currentAccount.ID));
  return currentSubscription?.BillingCycles.find(({ Status }) => Status === "PENDING_ACTIVATION");
};
